import React from "react";
import "./Container.css";

const Container = React.forwardRef(({ children, className = "", style = {} }, ref) => {
    return <div className={`custom-container ${className}`} style={style} ref={ref}>
        {children}
    </div>
});

export default Container